"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChatBase_1 = __importDefault(require("../../core/ChatBase"));
var decorators_1 = require("../../core/decorators");
var TawkTo = /** @class */ (function (_super) {
    __extends(TawkTo, _super);
    function TawkTo(_id) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this._eventMap = {
            load: 'onLoad',
            stateChange: 'onStatusChange',
            preSubmit: ['onPrechatSubmit', function (data) { return data; }],
            offlineSubmit: ['onOfflineSubmit', function (data) { return data; }],
            open: 'onChatMaximized',
            close: 'onChatMinimized',
            start: 'onChatStarted',
            end: 'onChatEnded',
            hidden: 'onChatHidden'
        };
        _super.prototype.init.call(_this);
        return _this;
    }
    TawkTo.prototype._loader = function () {
        window.Tawk_API = window.Tawk_API || {};
        // TawkTo events need to be set before instance is created
        this._api = window.Tawk_API;
        // Load main chat script
        window.Tawk_LoadStart = new Date();
        var s1 = document.createElement('script');
        var s0 = document.getElementsByTagName('script')[0];
        s1.async = true;
        s1.src = "https://embed.tawk.to/" + this._id;
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        // @ts-ignore
        s0.parentNode.insertBefore(s1, s0);
        return window.Tawk_API;
    };
    TawkTo.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.Tawk_API.maximize();
                return [2 /*return*/];
            });
        });
    };
    TawkTo.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.Tawk_API.minimize();
                return [2 /*return*/];
            });
        });
    };
    TawkTo.prototype.end = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.Tawk_API.endChat();
                return [2 /*return*/];
            });
        });
    };
    TawkTo.prototype.event = function (eventName, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        window.Tawk_API.addEvent(eventName, data, function (error) {
                            if (error)
                                reject(error);
                            resolve();
                        });
                    })];
            });
        });
    };
    TawkTo.prototype.popup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.Tawk_API.popup();
                return [2 /*return*/];
            });
        });
    };
    TawkTo.prototype.addTags = function (tags) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        window.Tawk_API.addTags(tags, function (error) {
                            if (error)
                                reject(error);
                            resolve();
                        });
                    })];
            });
        });
    };
    TawkTo.prototype.removeTags = function (tags) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        window.Tawk_API.removeTags(tags, function (error) {
                            if (error)
                                reject(error);
                            resolve();
                        });
                    })];
            });
        });
    };
    TawkTo.prototype.setVisitorData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        window.Tawk_API.setAttributes(data, function (error) {
                            if (error)
                                reject(error);
                            resolve();
                        });
                    })];
            });
        });
    };
    TawkTo.prototype.toggle = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.Tawk_API.toggle();
                return [2 /*return*/];
            });
        });
    };
    TawkTo.prototype.isChatting = function () {
        return window.Tawk_API.isChatOngoing();
    };
    TawkTo.prototype.isClosed = function () {
        return window.Tawk_API.isChatMinimized();
    };
    TawkTo.prototype.isEngaged = function () {
        return window.Tawk_API.isVisitorEngaged();
    };
    TawkTo.prototype.isHidden = function () {
        return window.Tawk_API.isChatHidden();
    };
    TawkTo.prototype.isOnline = function () {
        return window.Tawk_API.getStatus() == 'online';
    };
    TawkTo.prototype.isOffline = function () {
        return window.Tawk_API.getStatus() == 'offline';
    };
    TawkTo.prototype.isAway = function () {
        return window.Tawk_API.getStatus() == 'away';
    };
    TawkTo.prototype.isOpen = function () {
        return window.Tawk_API.isChatMaximized();
    };
    TawkTo.prototype.state = function () {
        return window.Tawk_API.getStatus();
    };
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "open", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "close", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "end", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "event", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "popup", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "addTags", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "removeTags", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "setVisitorData", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TawkTo.prototype, "toggle", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isChatting", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isClosed", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isEngaged", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isHidden", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isOnline", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isOffline", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isAway", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], TawkTo.prototype, "isOpen", null);
    __decorate([
        decorators_1.jsApiMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", String)
    ], TawkTo.prototype, "state", null);
    return TawkTo;
}(ChatBase_1.default));
exports.default = TawkTo;
//# sourceMappingURL=TawkTo.js.map